import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'

/**
 * loading substate - intentionally empty, this prevents the async transitions from going all the way back to the
 * application-loading substate. We currently handle displaying a loading indicator overlay with the subscription-type
 * controller. We don't want the application-loading substate shown after the app has loaded, because it causes the
 * application template to be removed and re-rendered.
 */
const LoadingTemplate: TOC<unknown> = <template></template>
export default RouteTemplate(LoadingTemplate)
